import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import MainPage from './components/MainPage.vue'
import LoginPage from './components/LoginPage.vue'
import BindPhonePage from './components/BindPhonePage.vue'
import ParentPage from './components/ParentPage.vue'
import TeacherPage from './components/TeacherPage.vue'
import MessageDetail from './components/MessageDetail.vue'

const routes = [
  { path: '/', component: MainPage },
  { path: '/login', component: LoginPage },
  { path: '/bindPhone', component: BindPhonePage },
  { path: '/parent', component: ParentPage },
  { path: '/teacher', component: TeacherPage },
  { path: '/messageDetail', component: MessageDetail }
]
 
const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)
app.use(router)
app.mount('#app')
